import TravelGuide from './components/TravelGuide'
import './App.css'

const App = () => <TravelGuide />

export default App
